// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__OpAkM","short":"styles_short__ds_B7","long":"styles_long__3p9Mb","container":"styles_container__czFaE"};